import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  unachivedAccountDetail,
  achivedAccountDetail,
  viewAccountDetail,
} from "../../../redux/features/verifyPAN/verifyPAN";
import {
  beneTxnWaitingApproval,
  beneTxnAccountDetail,
  beneTxnViewAllAcc,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { checkUsertoken } from "../../../redux/features/login/login";
import whiteLoader from "../../../assets/Approve transactions/WhiteLoaderImages.png";
import { toast, Bounce } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import "./index.css";
import xpentraloader from "../../../assets/Beneficiary Icons/lodemore.gif";
import DeclinedPopup from "../../../containers/Accounts/BeneficiaryAccount/BeneAcountApproval/DeclinedPopup";
import RefreshToast from "../../_utils/RefreshToast";
import { useNavigate } from "react-router-dom";
import { internalTxnViewAll } from "../../../redux/features/internalTransaction/internalTransactionViewAll";

const BeneDetailModal = ({
  close,
  id,
  type,
  message,
  note,
  title,
  accountData,
  updateAllAccounts,
  setRejectTxnPopup,
  setAchivedOpenPop,
  onClose,
  accountId,
  allAccounts,
  createEdit,
  txn_single_appr,
}) => {
  const dispatch = useDispatch();

  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const Navigate = useNavigate();
  const { viewAccountDetailData, viewAccountDetailError } = useSelector(
    (state) => state.verify
  );
  const handleConfirm = async () => {
    try {
      let thunkAction;
      switch (type) {
        case "approve transaction":
          const loginid = JSON.parse(localStorage.getItem("response"));
          thunkAction = beneTxnWaitingApproval;
          dispatch(checkUsertoken());
          const res = await dispatch(thunkAction(id));

          if (
            res?.payload?.status === false ||
            res.type === "beneTxnWaitingApproval/rejected"
          ) {
            let errorMessage = "";
            const updatedData = accountData?.map((item) => {
              if (item.txn_id === id) {
                if (
                  res?.payload?.errors?.base[0]?.errors &&
                  res?.payload?.errors?.base[0]?.errors[0]?.reason[0]
                ) {
                  errorMessage = res.payload.errors.base[0].errors[0].reason[0];
                } else if (
                  res?.payload?.errors?.base[0]?.errors &&
                  res?.payload?.errors[0]?.reason
                ) {
                  errorMessage = res.payload.errors.base[0]?.errors[0]?.reason;
                } else if (res?.payload?.errors?.base[0]?.reason[0]) {
                  errorMessage = res?.payload?.errors?.base[0]?.reason[0];
                } else if (res?.payload?.errors?.base[0]) {
                  errorMessage = res.payload.errors.base[0];
                }
                return {
                  ...item,
                  error:
                    item.error === false && res?.payload?.status === false
                      ? true
                      : item.error,
                  message:
                    item.message === "" && res?.payload?.status === false
                      ? errorMessage
                      : item.message,
                };
              }
              return item;
            });
            if (errorMessage) {
              toast.error(errorMessage, toast_position);
              setShowLoader(false);
            }
            updateAllAccounts(updatedData);
          } else {
            let newCycleStatus = "";
            const updatedData = accountData.map((item) => {
              if (item.txn_id === id) {
                if (
                  res?.payload?.status === true &&
                  res?.payload?.transactions[0]?.lifecycle_status === "approved"
                ) {
                  newCycleStatus =
                    res?.payload?.transactions[0]?.lifecycle_status;
                } else if (
                  res?.payload?.status === true &&
                  res?.payload?.transactions[0]?.lifecycle_status === "pending"
                ) {
                  newCycleStatus = "pendingOne";
                }
                return {
                  ...item,
                  last_updated_status:
                    item.last_updated_status === "Created" &&
                    res?.payload?.status === true &&
                    res?.payload?.transactions[0]?.last_updated_status ===
                      "Approved"
                      ? "Approved"
                      : "Created",

                  lifecycle_status:
                    res?.payload?.status === true &&
                    item.lifecycle_status === "pending"
                      ? newCycleStatus
                      : "",

                  last_updated_user_id:
                    res?.payload?.status === true &&
                    res?.payload?.transactions[0]?.last_updated_user_id
                      ? res?.payload?.transactions[0].last_updated_user_id
                      : item.last_updated_user_id,

                  last_updated_user_id_check:
                    item.last_updated_user_id_check === false &&
                    res?.payload?.status === true &&
                    loginid?.employees?.id ===
                      res?.payload.transactions[0].last_updated_user_id
                      ? true
                      : false,

                  distribution_lifecycle_status:
                    res?.payload?.transactions[0]
                      ?.distribution_lifecycle_status || "",
                };
              }
              return item;
            });
            toast.success("Transaction approved", toast_position);
            updateAllAccounts(updatedData);

            if (txn_single_appr === "txn_single_approval") {
              Navigate(-1);
            }
          }

          close(false);
          break;

        case "internalAccount":
          const account = viewAccountDetailData?.beneficiary_accounts?.[0];

          if (account?.archived === "N") {
            thunkAction = achivedAccountDetail;
            RefreshToast("archive");

            dispatch(checkUsertoken());
            const response = await dispatch(thunkAction({ id, Navigate }));
            if (
              response.type !== `${thunkAction.name}/rejected` &&
              response.payload
            ) {
              await dispatch(viewAccountDetail({ id }));
              close(true);
              setAchivedOpenPop(false);
            }
          } else if (account?.approval_status === "archived") {
            thunkAction = unachivedAccountDetail;
            RefreshToast("unarchive");

            dispatch(checkUsertoken());
            const response = await dispatch(thunkAction({ id, Navigate }));

            if (
              response.type !== `${thunkAction.name}/rejected` &&
              response.payload
            ) {
              await dispatch(viewAccountDetail({ id }));
            }
            close(true);
          }
          break;

        case "archived":
          if (type?.internalAccount !== "internalAccount") {
            thunkAction = achivedAccountDetail;
            dispatch(checkUsertoken());
            RefreshToast("archive");
            const archived_response = await dispatch(
              thunkAction({ id, Navigate })
            );
            if (
              archived_response.type !== "achivedAccountDetail/rejected" ||
              archived_response.payload ===
                "Beneficiary account already archived"
            ) {
              dispatch(checkUsertoken());
              await dispatch(viewAccountDetail({ id }));
            }

            close(true);
            setAchivedOpenPop(false);
          }
          break;

        case "unarchived":
          if (type.internalAccount !== "internalAccount") {
            thunkAction = unachivedAccountDetail;
            dispatch(checkUsertoken());
            RefreshToast("unarchive");
            const unarchived_response = await dispatch(
              thunkAction({ id, Navigate })
            );
            if (
              unarchived_response.type !== "unachivedAccountDetail/rejected" ||
              unarchived_response.payload ===
                "Beneficiary account already pending"
            ) {
              dispatch(checkUsertoken());
              await dispatch(viewAccountDetail({ id }));
            }
            close(false);
          }
          break;
      }
    } catch (error) {
      (() => {})();
    }
    close(true);
  };

  const handleRejectTransactionChecker = async () => {
    setShowLoader(true);
    let queryParams = {
      page_no: 1,
      page_item_count: 50,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };
    dispatch(checkUsertoken());
    // RefreshToast("archive");
    let response = [];
    if (type === "internalAccount") {
      response = await dispatch(internalTxnViewAll(queryParams));
    } else {
      response = await dispatch(beneTxnViewAllAcc(queryParams));
    }

    const data = response?.payload?.transactions;

    if (data?.length > 0 && response?.payload?.status) {
      setRejectTxnPopup(true);
      setAchivedOpenPop(false);
    } else {
      handleConfirm();
    }
  };

  return (
    <>
      {type == "Reject-All-Transaction" ? (
        <>
          <div className="fixed top-0 left-0 w-full h-full bg-custom-backdrop bg-opacity-80 flex items-center justify-center z-[9998]">
            <DeclinedPopup
              status={type}
              onClose={onClose}
              accountId={accountId}
              archive_id={id}
              allAccounts={allAccounts}
              updateAllAccounts={updateAllAccounts}
              setRejectTxnPopup={setRejectTxnPopup}
              createEdit={createEdit}
              createArchive={"createArchive"}
            />
          </div>
        </>
      ) : (
        <>
          <div
            className="flex justify-center items-center m-auto top-1/2 left-1/2 fixed z-[9999] p-3"
            style={{ transform: "translate(-50%, -50%)" }}
          >
            <div
              className="h-fit w-70% flex flex-col gap-[40px] px-[20px] pb-[20px] pt-[12px] bg-custom-appBackLight rounded-2xl"
              // style={{ width: "400px", maxWidth: "600px" }}
              style={{
                width: window.innerWidth <= 768 ? "350px" : "485px",
                maxWidth: "600px",
              }}
            >
              <div className="">
                <h6 className="text-custom-orange font-semibold font-sans text-Font_20">
                  {title}
                </h6>

                <div className="flex items-center pb-[4px]"></div>
                <div className="">
                  <span className="" style={{ wordWrap: "break-word" }}>
                    {message.split("\n").map((line, index) => (
                      <>
                        <p
                          className="mb-[20px] text-Primary_white text-Font_16 font-normal font-sans"
                          key={index}
                        >
                          {line}
                        </p>
                      </>
                    ))}
                  </span>
                  {note ? (
                    <span className="text-Font_16 font-normal font-sans text-Primary_grey">
                      Note - {note}
                    </span>
                  ) : null}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "6%",
                    // margin: "0px 50px",
                    width: "100%",
                  }}
                  className={`${
                    title === "Transaction Approval" ? null : "mt-[20px]"
                  }`}
                >
                  {!showLoader && (
                    <Button
                      onClick={() => {
                        close(false);
                      }}
                      sx={{
                        borderColor: "none",
                        color: "var(--Primary_white)",
                        fontSize: "var(--Font_12)",
                        fontWeight: "var(--Font_normal)",
                        fontFamily: "Open Sans",
                        textTransform: "capitalize",
                        textDecoration: "underline",
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                  {showLoader ? (
                    <>
                      <button className="expentra-Loader-class">
                        <img src={xpentraloader} alt="Loading..." />
                      </button>
                    </>
                  ) : (
                    <>
                      <Button
                        disabled={isButtonDisable}
                        sx={{
                          borderRadius: "20px",
                          color: "var(--Primary_white) !important",
                          fontSize: "var(--Font_12)",
                          fontWeight: "var(--Font_semibold)",
                          fontFamily: "Open Sans",
                          textTransform: "capitalize",
                          backgroundColor: "var(--Button_green)",

                          "&:hover": {
                            backgroundColor: "var(--Button_green_hover)",
                          },
                          // marginRight: "30px",
                          width: "79px",
                          height: "32px",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleRejectTransactionChecker();
                        }}
                      >
                        {title === "Unarchive account"
                          ? "Unarchive"
                          : "Archive"}
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BeneDetailModal;
